"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMachineAds = getMachineAds;
async function getMachineAds(advertisingRepo, machineId) {
    return advertisingRepo.getMachineAds(machineId);
}
